import type {
  NoteWriteback,
  NoteWritebackApi,
  MessagingNoteWriteback,
  MessagingNoteWritebackApi,
} from 'src/types/note-writeback';
import type {EmailApi} from 'src/types/email';


export const getDefaultNoteWritebackState = (): NoteWriteback => {
  return {
    nwbEntityType: null,
    nwbExternalEntityId: null,
    nwbNoteAction: null,
    nwbEnabled: false,
  };
};

export const getMessagingDefaultNoteWritebackState =
  (): MessagingNoteWriteback => {
    return {
      nwbSentEntityType: null,
      nwbSentExternalEntityId: null,
      nwbSentNoteAction: null,
      nwbSentEnabled: true,
      nwbReplyEntityType: null,
      nwbReplyExternalEntityId: null,
      nwbReplyNoteAction: null,
      nwbReplyEnabled: true,
    };
  };

export const parseNoteWriteback = (
  emailApiResponse: EmailApi,
): NoteWriteback => {
  const nwbEntityType = emailApiResponse.nwb_external_entity_type;
  const nwbExternalEntityId = emailApiResponse.nwb_external_entity_id;
  const nwbNoteAction = emailApiResponse.note_action;
  const nwbEnabled = emailApiResponse.nwb_enabled;
  return {
    nwbEntityType,
    nwbExternalEntityId,
    nwbNoteAction,
    nwbEnabled,
  };
};

export const normalizeNoteWriteback = (
  noteWriteback: NoteWriteback,
): NoteWritebackApi => {
  const {nwbEntityType, nwbExternalEntityId, nwbNoteAction, nwbEnabled} =
    noteWriteback;
  if (!nwbEnabled) {
    return {
      nwb_external_entity_type: null,
      nwb_external_entity_id: null,
      note_action: null,
      nwb_enabled: false,
    };
  }
  return {
    nwb_external_entity_type: nwbEntityType,
    nwb_external_entity_id: nwbExternalEntityId,
    note_action: nwbNoteAction,
    nwb_enabled: nwbEnabled,
  };
};

export const normalizeMessagingNoteWriteback = (
  messagingState: MessagingNoteWriteback,
): MessagingNoteWritebackApi => {
  const {
    nwbSentEntityType,
    nwbSentExternalEntityId,
    nwbSentNoteAction,
    nwbSentEnabled,
    nwbReplyEntityType,
    nwbReplyExternalEntityId,
    nwbReplyNoteAction,
    nwbReplyEnabled,
  } = messagingState;

  return {
    nwb_sent_external_entity_type: nwbSentEntityType,
    nwb_sent_external_entity_id: nwbSentExternalEntityId,
    sent_note_action: nwbSentNoteAction,
    nwb_sent_enabled: nwbSentEnabled,
    nwb_reply_external_entity_type: nwbReplyEntityType,
    nwb_reply_external_entity_id: nwbReplyExternalEntityId,
    reply_note_action: nwbReplyNoteAction,
    nwb_reply_enabled: nwbReplyEnabled,
  };
};

export const parseMessagingNoteWriteback = (
  messagingApiResponse: any,
): MessagingNoteWriteback => {
  return {
    nwbSentEntityType: messagingApiResponse.nwb_sent_external_entity_type,
    nwbSentExternalEntityId: messagingApiResponse.nwb_sent_external_entity_id,
    nwbSentNoteAction: messagingApiResponse.sent_note_action,
    nwbSentEnabled: messagingApiResponse.nwb_sent_enabled,
    nwbReplyEntityType: messagingApiResponse.nwb_reply_external_entity_type,
    nwbReplyExternalEntityId: messagingApiResponse.nwb_reply_external_entity_id,
    nwbReplyNoteAction: messagingApiResponse.reply_note_action,
    nwbReplyEnabled: messagingApiResponse.nwb_reply_enabled,
  };
};
